import { z } from 'zod'
import { SummaryOutputSchema } from './sessionSummarizers'
export const DailyTestingSummarySchema = z.object({
  day: z.string(), timezone: z.string(), summary: z.string().nullable(), updated_at: z.string().nullable(),
})
export const DailyTestingEvidenceSchema = z.object({
  day: z.string(), timezone: z.string(), existing_summary: z.string().nullable(),
  reports: z.array(z.object({ name: z.string(), output: SummaryOutputSchema })),
  runs: z.array(z.object({ id: z.string(), status: z.string(),
    journeys: z.array(z.object({ name: z.string(), status: z.string(), outcome: z.string().nullable() })),
    explorations: z.array(z.object({ status: z.string(), prompt: z.string(), blocked_detail: z.string().nullable() })),
  })),
  bugs: z.array(z.object({ id: z.string(), title: z.string(), status: z.string(), severity: z.string().nullable() })),
})
